function toCoverMap(modules: Record<string, string>): Map<string, string> {
  const bySlug = new Map<string, string>()
  for (const [path, url] of Object.entries(modules)) {
    const filename = path.split('/').pop() ?? ''
    bySlug.set(filename.replace(/\.webp$/i, ''), url)
  }
  return bySlug
}

const coversBySlug = toCoverMap(
  import.meta.glob('../assets/category_covers/*.webp', {
    eager: true,
    query: '?url',
    import: 'default',
  }) as Record<string, string>,
)
const cardsBySlug = toCoverMap(
  import.meta.glob('../assets/category_covers/cards/*.webp', {
    eager: true,
    query: '?url',
    import: 'default',
  }) as Record<string, string>,
)
const thumbsBySlug = toCoverMap(
  import.meta.glob('../assets/category_covers/thumbs/*.webp', {
    eager: true,
    query: '?url',
    import: 'default',
  }) as Record<string, string>,
)

export const CATEGORY_COVER_SLUGS = [...coversBySlug.keys()].sort()

function slugFromName(name: string): string {
  return name
    .toLowerCase()
    .replaceAll('à', 'a')
    .replaceAll('è', 'e')
    .replaceAll('é', 'e')
    .replaceAll('ì', 'i')
    .replaceAll('ò', 'o')
    .replaceAll('ù', 'u')
    .replaceAll(/[^a-z0-9]+/g, '_')
    .replaceAll(/^_+|_+$/g, '')
}

function lookup(map: Map<string, string>, slug: string, name: string): string {
  const key = slug.trim() || slugFromName(name)
  return map.get(key) ?? map.get(slugFromName(name)) ?? ''
}

/**
 * Maps the API `categorySlug` (or a category name fallback) to the frozen
 * full-size cover used by detail/hero surfaces. Unknown categories fall back to
 * `altro`, matching UI_PARITY.
 */
export function categoryCoverUrl(slug: string, name = ''): string {
  return (
    lookup(coversBySlug, slug, name) || coversBySlug.get('altro') || ''
  )
}

/**
 * Small square crop for list rows and cards. Falls back to the full cover so a
 * missing generated variant never breaks the UI.
 */
export function categoryCardUrl(slug: string, name = ''): string {
  return (
    lookup(cardsBySlug, slug, name) ||
    cardsBySlug.get('altro') ||
    categoryCoverUrl(slug, name) ||
    ''
  )
}

/** Tiny square crop for the 28 px category chips. */
export function categoryThumbUrl(slug: string, name = ''): string {
  return (
    lookup(thumbsBySlug, slug, name) ||
    thumbsBySlug.get('altro') ||
    categoryCardUrl(slug, name) ||
    ''
  )
}
